export default __webpack_public_path__ + "media/images/logo-pds-rgb-1483df326df642ea7c4416d5c4b34fc1.svg";